module.exports = __webpack_public_path__ + "static/second-d5e4a65d31e5d9698a31d501510c05c4.jpg";